import { Scissors, Sparkle, Wrench, ForkKnife, Storefront } from "@phosphor-icons/react";

export const VERTICAL_META = {
  barbieri: { label: "Barbieri", Icon: Scissors },
  beauty: { label: "Beauty", Icon: Sparkle },
  manutentori: { label: "Manutentori", Icon: Wrench },
  ristorazione: { label: "Ristorazione", Icon: ForkKnife },
};

export const VerticalIcon = ({ v, ...props }) => {
  const Cmp = VERTICAL_META[v]?.Icon || Storefront;
  return <Cmp {...props} />;
};

export const eur = (n) => `€${Number(n).toFixed(2).replace(".00", "")}`;
